import { render, staticRenderFns } from "./AdvancedAlertTable.vue?vue&type=template&id=23fd5ec7&"
import script from "./AdvancedAlertTable.vue?vue&type=script&lang=js&"
export * from "./AdvancedAlertTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports